import { z } from 'zod/v3';
import { errorMap } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { ChangedBySchema } from '../../user';
import { SampleCommentValidFormDataType } from './types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './SampleCommentSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('sample-comment-schema');
addTranslations(translations);

export const SAMPLE_COMMENT_GROUP_VALUE = 'GROUP';

export const SampleCommentsSchema = z.object({
  id: z.number(),
  sampleId: z.number(),
  sampleGroupId: z.number().nullish(),
  sampleDataObjectDescriptionId: z.number().nullish(),
  sampleDataObjectDescriptionCode: z.string().nullish(),
  sampleDataObjectDescriptionName: z.string().nullish(),
  comments: z.string().nullish(),
  createdAt: zIsoDateTime().nullish(),
  createdBy: ChangedBySchema.nullish(),
  modifiedAt: zIsoDateTime().nullish(),
  modifiedBy: ChangedBySchema.nullish(),
});

export const SampleCommentValidFormDataSchema = SampleCommentsSchema.omit({
  id: true,
  sampleDataObjectDescriptionId: true,
  comments: true,
}).extend({
  id: z.number().nullish(),
  sampleDataObjectDescriptionId: z.preprocess(
    (value) => (value == null ? SAMPLE_COMMENT_GROUP_VALUE : value),
    z.union([z.number(), z.literal(SAMPLE_COMMENT_GROUP_VALUE)]),
  ),
  comments: z
    .string(
      errorMap((issue) =>
        issue.code === z.ZodIssueCode.too_big
          ? t('validation.comments.too_big')
          : t('validation.comments.required'),
      ),
    )
    .min(1)
    .max(2000)
    .nullish(),
});

export const SampleCommentMutationDtoSchema =
  SampleCommentValidFormDataSchema.transform(
    ({ id, sampleId, sampleDataObjectDescriptionId, comments }) => ({
      id: id ?? null,
      sampleId,
      sampleDataObjectDescriptionId:
        sampleDataObjectDescriptionId === SAMPLE_COMMENT_GROUP_VALUE
          ? null
          : sampleDataObjectDescriptionId,
      comments,
    }),
  );

export class SampleCommentSchema {
  static parseFormData<Dto>(data: Dto): SampleCommentValidFormDataType {
    return SampleCommentValidFormDataSchema.parse(data);
  }
}
